class MidasGuide extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.questions = [...this.querySelectorAll('.guide__question')];
    this.results = [...this.querySelectorAll('[data-result-key]')];
    this.resultsStep = this.querySelector('[data-step="result"]');
    this.status = this.querySelector('[data-guide-status]');
    this.branching = Boolean(this.querySelector('[data-guide-option][data-next]'));
    this.history = [];
    this.classList.add('is-interactive');
    this.querySelector('[data-guide-top]').hidden = false;
    this.querySelectorAll('[data-guide-start], [data-guide-restart]').forEach(b => b.addEventListener('click', () => this.restart()));
    this.querySelectorAll('[data-guide-back]').forEach(b => b.addEventListener('click', () => this.back()));
    this.querySelector('form').addEventListener('submit', e => e.preventDefault());
    this.addEventListener('change', e => {
      if (!e.target.matches('[data-guide-option]')) return;
      clearTimeout(this.advanceTimer);
      this.advanceTimer = setTimeout(() => this.advance(e.target), 240);
    });
    this.show(this.questions[0]?.dataset.questionKey, false);
  }

  disconnectedCallback() { clearTimeout(this.advanceTimer); clearTimeout(this.focusTimer); }

  remaining(key, seen = new Set()) {
    const q = this.questions.find(q => q.dataset.questionKey === key);
    if (!q || seen.has(key)) return 0;
    seen.add(key);
    if (!this.branching) return this.questions.length - this.questions.indexOf(q);
    return 1 + Math.max(0, ...[...q.querySelectorAll('[data-guide-option]')].map(i => this.remaining(i.dataset.next, new Set(seen))));
  }

  show(key, focus = true) {
    clearTimeout(this.advanceTimer);
    clearTimeout(this.focusTimer);
    this.shown = key;
    this.querySelector('[data-step="intro"]').hidden = true;
    this.resultsStep.hidden = key !== 'result';
    this.questions.forEach(q => q.hidden = q.dataset.questionKey !== key);
    const result = key === 'result';
    this.querySelector('[data-guide-form]').hidden = result;
    const step = this.history.length + 1;
    const total = this.history.length + this.remaining(key);
    this.querySelector('[data-guide-counter]').textContent = result ? 'Your match' : `Question ${step} of ${total}`;
    this.querySelector('[data-guide-meter]').style.setProperty('--guide-progress', `${result ? 100 : (step / total) * 100}%`);
    this.querySelectorAll('[data-guide-back]').forEach(b => b.hidden = !this.history.length);
    const panel = result ? this.resultsStep : this.questions.find(q => q.dataset.questionKey === key);
    if (focus) {
      const heading = panel?.querySelector('legend, .guide__result-label');
      if (heading) { heading.tabIndex = -1; this.focusTimer = setTimeout(() => heading.focus({preventScroll:true}), 0); }
    }
    if (this.status) this.status.textContent = result ? 'Your hair match is ready.' : `Question ${step} of ${total}`;
  }

  advance(input) {
    const current = input.closest('.guide__question');
    if (current.dataset.questionKey !== this.shown) return;
    this.history.push(current.dataset.questionKey);
    if (!this.branching) {
      const next = this.questions[this.questions.indexOf(current) + 1];
      return next ? this.show(next.dataset.questionKey) : this.finish();
    }
    const target = input.dataset.next;
    if (this.questions.some(q => q.dataset.questionKey === target)) this.show(target);
    else this.finish(target);
  }

  back() {
    clearTimeout(this.advanceTimer);
    const key = this.history.pop();
    if (!key) return;
    this.questions.filter(q => !this.history.includes(q.dataset.questionKey)).forEach(q => q.querySelectorAll('input').forEach(i => i.checked = false));
    this.show(key);
  }

  restart() {
    this.querySelectorAll('[data-guide-option]').forEach(i => i.checked = false);
    this.history = [];
    this.show(this.questions[0]?.dataset.questionKey);
  }

  finish(key) {
    const answers = [...this.querySelectorAll('[data-guide-option]:checked')];
    const tags = new Set(answers.flatMap(i => i.value.split(',').map(t => t.trim()).filter(Boolean)));
    const fallback = this.results.find(r => r.hasAttribute('data-result-fallback'));
    const matching = this.results.filter(r => {
      const required = (r.dataset.resultTags || '').split(',').map(t => t.trim()).filter(Boolean);
      return required.length && required.every(t => tags.has(t));
    }).sort((a,b) => b.dataset.resultTags.split(',').length - a.dataset.resultTags.split(',').length);
    let winner = key ? this.results.find(r => r.dataset.resultKey === key) : matching[0];
    if (!winner) winner = fallback;
    if (!winner && !this.branching) {
      const tally = new Map();
      answers.forEach(i => i.value.split(',').map(t => t.trim()).forEach(t => tally.set(t,(tally.get(t)||0)+1)));
      winner = [...this.results].sort((a,b) => (tally.get(b.dataset.resultKey)||0)-(tally.get(a.dataset.resultKey)||0))[0];
    }
    winner ||= this.results[0];
    this.results.forEach(r => r.hidden = r !== winner);
    const reason = this.querySelector('[data-guide-reason]');
    const preferences = [];
    if(tags.has('straight')) preferences.push('a sleek, straight finish');
    if(tags.has('wave')) preferences.push('a style that holds a curl');
    if(tags.has('curl')) preferences.push('wash-and-go texture');
    if(tags.has('yaki')) preferences.push('a textured straight look');
    if(tags.has('raw')) preferences.push('longest wear');
    if(tags.has('virgin')) preferences.push('a lower price');
    reason.textContent = preferences.length ? `You chose ${preferences.join(' and ')}.` : 'Based on your choices.';
    reason.hidden = false;
    this.show('result');
  }
}
customElements.define('midas-guide', MidasGuide);
